export default __webpack_public_path__ + "4401598166dfa38f305e7a3595487a77.png";